const ClientsCibles = () => {
  const clients = [
    {
      icon: '🏛️',
      title: 'Municipalités',
      description: 'Modernisez la gestion du stationnement dans votre ville. Optimisez les revenus, améliorez le contrôle et offrez un meilleur service aux citoyens.',
      besoins: [
        'Digitalisation des services publics',
        'Optimisation des revenus de parking',
        'Amélioration du contrôle et de la conformité',
        'Données pour la planification urbaine'
      ],
      couleur: 'from-blue-500 to-blue-600'
    },
    {
      icon: '🏢',
      title: 'Entreprises privées',
      description: 'Gérez efficacement les parkings de vos centres commerciaux, hôtels, ou entreprises. Offrez une expérience premium à vos clients.',
      besoins: [
        'Gestion centralisée des parkings',
        'Intégration avec vos systèmes existants',
        'Analytics pour optimiser l\'occupation',
        'Expérience client améliorée'
      ],
      couleur: 'from-purple-500 to-purple-600'
    },
    {
      icon: '👥',
      title: 'Citoyens tunisiens',
      description: 'Simplifiez votre quotidien avec une application intuitive. Trouvez un parking rapidement, payez facilement, gagnez du temps.',
      besoins: [
        'Gain de temps dans la recherche de parking',
        'Paiement digital sécurisé',
        'Gestion simplifiée des tickets',
        'Notifications et alertes utiles'
      ],
      couleur: 'from-green-500 to-green-600'
    }
  ];

  return (
    <section id="clients" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Pour qui ?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tunisie Parking s'adresse à tous les acteurs de l'écosystème du stationnement en Tunisie, 
            dans le cadre de la digitalisation nationale.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {clients.map((client, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-200"
            >
              <div className={`bg-gradient-to-br ${client.couleur} p-8 text-white`}>
                <div className="text-5xl mb-4">{client.icon}</div>
                <h3 className="text-2xl font-bold mb-3">{client.title}</h3>
                <p className="text-white/90 leading-relaxed">
                  {client.description}
                </p>
              </div>
              
              <div className="p-6">
                <h4 className="text-lg font-semibold text-gray-900 mb-4">
                  Vos besoins :
                </h4>
                <ul className="space-y-3">
                  {client.besoins.map((besoin, idx) => (
                    <li key={idx} className="flex items-start text-gray-700">
                      <svg className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>{besoin}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-primary-50 to-blue-50 rounded-xl p-6 border border-primary-200">
          <div className="text-center">
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              🌍 Un projet pour la Tunisie de demain
            </h3>
            <p className="text-base text-gray-700 max-w-2xl mx-auto">
            Dans le cadre de <strong>nextTunisia</strong> et de la vision de digitalisation 
              du pays à l'horizon 2030, Tunisie Parking contribue à moderniser les services publics 
              et à améliorer la qualité de vie des citoyens. Rejoignez-nous dans cette transformation digitale !
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsCibles;

